export default __webpack_public_path__ + "static/media/testDoc.c0b89ebd.svg";